const sortingConfig = {
    byPopularity: {
        key: 'default',
        order: 'custom'
    },
    priceAsc: {
        key: 'price',
        order: 'asc'
    },
    priceDesc: {
        key: 'price',
        order: 'desc'
    },
    titleAsc: {
        key: 'title',
        order: 'asc'
    },
    titleDesc: {
        key: 'title',
        order: 'desc'
    }
}

export default sortingConfig;